// extracted by mini-css-extract-plugin
export default {"PersonalDetails":"PersonalDetails_PersonalDetails__agCwj","contact":"PersonalDetails_contact__aZKID","about":"PersonalDetails_about__5nqMI"};